app.ui.addFeature('fieldController', function () {
  'use strict';

  const self = this;

  /*
    Name: init
    Use: API.init()
    Args: none
    Description: Initializes the component
  */
  self.init = function () {};

  const getFieldInfo = function (field) {
    return {
      required: app.misc.isValueTrue(field.required) ? 'required' : '',
      type: field.type || '',
      id: field.properties.id,
      label: field.properties.label,
      placeholder: !app.misc.isValueTrue(field.properties.disabled) && field.properties.placeholder ? `placeholder="${field.properties.placeholder}"` : '',
      disabled: app.misc.isValueTrue(field.properties.disabled) ? 'disabled' : '',
      dataPath: field.dataPath || '',
      defaultValue: field.default || '',
      options: Array.isArray(field.options) ? field.options : [],
      childFields: Array.isArray(field.childFields) ? field.childFields : [],
      inputMask: field.properties.inputMask !== undefined ?
        `inputmask="${field.properties.inputMask}" data-mask="${field.properties.inputMask}"` : '',
      pattern: field.properties.pattern !== undefined ? `pattern="${field.properties.pattern}"` : '',
      secureInput: field.secureInput || '',
      multiple: field.properties.multiple,
      fieldSubtext: field.properties.fieldSubtext || '',
      actions: field.actions || {},
      minDate: field.properties.minDate || '',
      maxDate: field.properties.minDate || '',
      minuteIncrement: field.properties.minuteIncrement || '',
    };
  }

  /*
    Name: textarea
    Use: API.textarea()
    Args: field Object - Field configuration definition
    Description: Textarea control
  */
  self.textarea = function (field) {
    const {
      required,
      id,
      label,
      placeholder,
      disabled,
      dataPath
    } = getFieldInfo(field);
    return `
      <label for="${id}" class="translateable">
        ${required ? '<sup class="fa fa-2xs fa-asterisk required-icon" title="Required"></sup> ' : ''}${label}
      </label>
      <textarea 
        name="${id}"
        ${required}
        class="form-control w-input"
        id="${id}"
        ${placeholder}
        data-path="${dataPath}" 
        v-model="${dataPath}" 
        ${disabled}
      >
      </textarea>
    `;
  };

  /*
    Name: date
    Use: API.date()
    Args: field Object - Field configuration definition
    Description: Date field control
  */
  self.date = function (field) {
    if (!field.properties.placeholder) {
      field.properties.placeholder = `MM/DD/YYYY`;
    }
    const {
      required,
      id,
      label,
      placeholder,
      disabled,
      dataPath
    } = getFieldInfo(field);
    return `
      <label for="${id}" class="translateable">
        ${required ? '<sup class="fa fa-2xs fa-asterisk required-icon" title="Required"></sup> ' : ''}${label}
      </label>
      <input
        name="${id}"
        ${required}
        type="text"
        class="form-control w-input date-field"
        id="${id}"
        ${placeholder}
        data-path="${dataPath}" 
        v-model="${dataPath}" 
        ${disabled}
      />
    `;
  };

  /*
    Name: time
    Use: API.time()
    Args: field Object - Field configuration definition
    Description: Time field control
  */
  self.time = function (field) {
    if (!field.properties.placeholder) {
      field.properties.placeholder = `HH:MM TT`;
    }
    const {
      required,
      id,
      label,
      placeholder,
      disabled,
      dataPath
    } = getFieldInfo(field);
    return `
      <label for="${id}" class="translateable">
        ${required ? '<sup class="fa fa-2xs fa-asterisk required-icon" title="Required"></sup> ' : ''}${label}
      </label>
      <input
        name="${id}"
        ${required}
        type="text"
        class="form-control w-input time-field"
        id="${id}"
        ${placeholder}
        data-path="${dataPath}" 
        v-model="${dataPath}" 
        ${disabled}
      />
    `;
  };

  /*
    Name: phone
    Use: API.phone()
    Args: field Object - Field configuration definition
    Description: Phone field control
  */
  self.phone = function (field) {
    if (!field.properties.placeholder) {
      field.properties.placeholder = `(000) 000-0000`;
    }
    const {
      required,
      id,
      label,
      placeholder,
      disabled,
      dataPath
    } = getFieldInfo(field);
    return `
      <label for="${id}" class="translateable">
        ${required ? '<sup class="fa fa-2xs fa-asterisk required-icon" title="Required"></sup> ' : ''}${label}
      </label>
      <input
        name="${id}"
        ${required}
        type="text"
        class="form-control w-input phone-field"
        data-validation="phone"
        data-mask="(000) 000-0000 ext. 000000"
        id="${id}"
        ${placeholder}
        data-path="${dataPath}" 
        v-model="${dataPath}" 
        ${disabled}
      />
    `;
  };

  /*
    Name: infobox
    Use: API.infobox()
    Args: field Object - Field configuration definition
    Description: Infobox field control for displaying readonly information
  */
  self.infobox = function (field) {
    const {
      id,
      dataPath,
      defaultValue
    } = getFieldInfo(field);
    return `
      <div
        id="${id}"
        type="infobox"
        data-path="${dataPath}"
        style="
          padding: 10px;
          background-color: rgb(219, 231, 242);
          margin: 10px;
          border: 1px dotted rgb(14, 157, 220);
        "
        class="translateable"
      >
        ${defaultValue}
      </div>
    `;
  };

  self.googlePlaceSearch = function (field) {
    (function () {
      const map = new google.maps.Map(document.getElementById('map'), {
        center: {
          lat: 35.2030728,
          lng: -80.9799136
        },
        zoom: 13,
      });
      const card = document.getElementById('pac-card');
      const input = document.getElementById('pac-input');

      map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);

      const autocomplete = new google.maps.places.Autocomplete(input);

      // Bind the map's bounds (viewport) property to the autocomplete object,
      // so that the autocomplete requests use the current map bounds for the
      // bounds option in the request.
      autocomplete.bindTo('bounds', map);

      // Set the data fields to return when the user selects a place.
      autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);

      const infowindow = new google.maps.InfoWindow();
      const infowindowContent = document.getElementById('infowindow-content');
      infowindow.setContent(infowindowContent);
      const marker = new google.maps.Marker({
        map: map,
        anchorPoint: new google.maps.Point(0, -29),
      });

      autocomplete.addListener('place_changed', function () {
        infowindow.close();
        marker.setVisible(false);
        const place = autocomplete.getPlace();
        if (!place.geometry) {
          // User entered the name of a Place that was not suggested and
          // pressed the Enter key, or the Place Details request failed.
          window.alert("No details available for input: '" + place.name + "'");
          return;
        }

        // If the place has a geometry, then present it on a map.
        if (place.geometry.viewport) {
          map.fitBounds(place.geometry.viewport);
        } else {
          map.setCenter(place.geometry.location);
          map.setZoom(17); // Why 17? Because it looks good.
        }
        marker.setPosition(place.geometry.location);
        marker.setVisible(true);

        let address = '';
        if (place.address_components) {
          address = [
            (place.address_components[0] && place.address_components[0].short_name) || '',
            (place.address_components[1] && place.address_components[1].short_name) || '',
            (place.address_components[2] && place.address_components[2].short_name) || '',
          ].join(' ');
        }

        infowindowContent.children['place-icon'].src = place.icon;
        infowindowContent.children['place-name'].textContent = place.name;
        infowindowContent.children['place-address'].textContent = address;
        infowindow.open(map, marker);
      });
    }).After(750);

    return `
      <div class="pac-card" id="pac-card">
        <div>
          <div id="title">
            Autocomplete search
          </div>
        </div>
        <div id="pac-container">
          <input name="pac-input" id="pac-input" type="text" placeholder="Enter a location">
        </div>
			</div>
      <div id="map"></div>
      <div id="infowindow-content">
        <img src="" width="16" height="16" id="place-icon">
        <span id="place-name" class="title"></span>
        <br>
        <span id="place-address"></span>
      </div>
    `;
  };

  /*
    Name: file
    Use: API.file()
    Args: field Object - Field configuration definition
    Description: File input control
  */
  self.file = function (field, renderedFormControl, jurisdiction) {
    const {
      required,
      id,
      label,
      placeholder,
      dataPath,
      type
    } = getFieldInfo(field);
    const acceptedUploadFileType = jurisdiction.hscSettings.acceptedUploadFileType;

    /*
      NOTE:
        Because we mix in traditional compiler with VueJS, we need to escape the VueJS double curly brackets with an exclamation and standard bracket which get replaced later
    */
    (function () {
      $(`#btn-upload-${id}`).on('click', function () {
        if ($(`#upload_${id}`)[0].files.length > 0 && !renderedFormControl.dataEntryApp.isProcessing) {
          upload();
        }
      });
      async function upload() {
        renderedFormControl.dataEntryApp.isProcessing = true;

        const jurisdictionPath = jurisdiction.path;
        let PhysicalCounty = '';
        if (jurisdictionPath === 'virginia') {
          PhysicalCounty = renderedFormControl.dataEntryApp.fieldValues?.PhysicalCounty || '';
        }
        const filesEl = document.getElementById(`upload_${id}`);
        const file = filesEl.files[0];

        if (acceptedUploadFileType?.length) {
          const fileExtension = file.name.split(".").pop().toLowerCase();
          const allowedTypesMap = acceptedUploadFileType.split(',').reduce((acc, type) => {
            const [ext, mimeType] = type.split('|');
            acc[ext] = mimeType;
            return acc;
          }, {});

          // Check if the file extension exists in the allowedTypesMap
          if (!allowedTypesMap[fileExtension]) {
            const allowedExtensions = Object.keys(allowedTypesMap).map(ext => `.${ext}`).join(', ');
            alert(`Error: File type not allowed. Please upload files of the following types: ${allowedExtensions}`);
            renderedFormControl.dataEntryApp.isProcessing = false;
            return false;
          }

          // Check if the file MIME type matches the allowed MIME type
          if (allowedTypesMap[fileExtension] !== fileMimeType) {
            alert(`Error: The file type "${fileMimeType}" does not match its extension ".${fileExtension}".`);
            renderedFormControl.dataEntryApp.isProcessing = false;
            return false;
          }
        }

        let uploadSuccess = false;

        try {
          const getPresignedResult = await fetch('/', {
            method: 'POST',
            body: JSON.stringify({
              task: 'getSignedS3',
              data: {
                jurisdiction: jurisdictionPath,
                signedOperation: 'putObject',
                formID: document.getElementById('formID').value,
                fileName: file.name,
                PhysicalCounty, // for vdh, used to determine the client nick dynamically
              },
            }),
            headers: {
              'Content-type': 'application/json',
            },
          });

          const presignedData = await getPresignedResult.json();

          if (presignedData.data.signedURL) {
            const uploadResponse = await fetch(presignedData.data.signedURL, {
              method: 'PUT',
              body: file,
              headers: {
                'Content-Type': file.type,
              },
            });

            if (uploadResponse.status === 200) {
              uploadSuccess = true;

              const comments = document.getElementById(`comments_${id}`).value;
              renderedFormControl.dataEntryApp.fieldValues[id].push({
                originalFileName: file.name,
                originalMimeType: file.type,
                s3url: presignedData.data.s3url,
                comments: comments,
              });

              $(`#${id}`).val(
                JSON.stringify(renderedFormControl.dataEntryApp.fieldValues[id])
              );
            }
          }
        } catch (err) {
          console.log(err);
        }

        renderedFormControl.dataEntryApp.isProcessing = false;

        $(`#upload_${id}`).val('');
        filesEl.value = '';

        if (!uploadSuccess) {
          alert('Error: failed to upload file');
        }
      }
    }).After(1000);

    return `
      <label for="upload_${id}" class="translateable">
        ${required ? '<sup class="fa fa-2xs fa-asterisk required-icon" title="Required"></sup> ' : ''}${label}
      </label>
      <div style="margin-bottom: 5px;padding: 15px;">
        <input
          name="upload_${id}"
          type="${type}"
          class="form-control w-input"
          id="upload_${id}"
          ${ acceptedUploadFileType?.length ? `accept="${acceptedUploadFileType?.replaceAll("|", ",").toLowerCase()}"` : ''}
          ${placeholder}
          ${type === 'number' ? `min="0"` : ''}
          data-path="${dataPath}"
        />
        <input name="comments_${id}" type="text" id="comments_${id}" placeholder="What is this document?" aria-label="${label} Description" class="form-control w-input">
        <button type="button" class="w-button" id="btn-upload-${id}">Upload File</button>
      </div>
      <div style="margin-bottom: 5px; border: 1px dotted #CCC; padding: 5px;">
        <h4 v-show="isProcessing">Uploading...</h4>
        <div v-show="fieldValues.${id}.length === 0 && !isProcessing">Upload one or more files above</div>
        <table class="table table-striped table-bordered" v-show="fieldValues.${id}.length > 0 && !isProcessing">
          <thead>
            <tr>
              <td>File</td>
              <td>Comments / File Type</td>
              <td>&nbsp;</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in fieldValues.${id}">
              <td>![row.originalFileName]!</td>
              <td>![row.comments]!</td>
              <td v-on:click="removeFieldArrayValue(index,'${id}')">
                <a href="javascript:void(0);">
                  <span class="fa fa-remove" aria-hidden="true"></span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <textarea class="form-control w-input" id="${id}" style="display:none;" data-path="${dataPath}"></textarea>
    `;
  };

  /*
    Name: checkbox
    Use: API.checkbox()
    Args: field Object - Field configuration definition
    Description: Checkboxes input control
  */
  self.checkbox = function (field) {
    const {
      required,
      id,
      label,
      dataPath,
      options
    } = getFieldInfo(field);

    let fieldHtml = `
      <label for="${id}" class="translateable">
        ${required ? '<sup class="fa fa-2xs fa-asterisk required-icon" title="Required"></sup> ' : ''}${label}
      </label>
    `;

    for (let i = 0; i < options.length; i++) {
      const opt = options[i];
      fieldHtml += `
        <div style="padding: 5px;border: 1px dotted #CCC;display:inline-block;margin:1px;">
          <input
            type="checkbox"
            name="${id}"
            value="${opt.value}"
            id="${id}${i}"
            data-path="${dataPath}"
            v-model="${dataPath}"
          />
          <label for="${id}${i}" class="translateable" style="display: inline-block;font-weight: 500;">&nbsp; ${opt.text}</label>
        </div>
      `;
    }

    return fieldHtml;
  };

  /*
    Name: default
    Use: API.default()
    Args: field Object - Field configuration definition
    Description: Default input control for things like text, number, etc.
  */
  self.default = function (field) {
    const {
      required,
      id,
      label,
      placeholder,
      dataPath,
      disabled,
      type,
      inputMask,
      pattern
    } = getFieldInfo(field);
    const compileSafePattern = pattern.replaceAll("{", "@$@").replaceAll("}", "@&@");

    return `
      <label for="${id}" class="translateable">
        ${required ? '<sup class="fa fa-2xs fa-asterisk required-icon" title="Required"></sup> ' : ''}${label}
      </label>
      <input 
        name="{properties.id}"
        ${required}
        ${compileSafePattern}
        type="${type}"
        class="form-control w-input"
        id="${id}"
        ${inputMask}
        ${placeholder}
        ${type === 'number' ? 'min="0"' : ''}
        data-path="${dataPath}"
        v-model="${dataPath}"
        ${disabled}
      />
    `;
  };

  /*
    Name: select
    Use: API.select()
    Args: field Object - Field configuration definition
    Description: Dropdown input control
  */
  self.select = function (field) {
    const {
      required,
      id,
      label,
      dataPath,
      disabled,
      options,
      multiple,
      fieldSubtext
    } = getFieldInfo(field);

    const multiSelect = multiple ? 'multiple' : '';

    let fieldHtml = `
      <label for="${id}" class="translateable">
        ${required ? '<sup class="fa fa-2xs fa-asterisk required-icon" title="Required"></sup> ' : ''}${label}
      </label>
      <select name="${id}" ${required} class="form-control w-select" id="${id}" data-path="${dataPath}" v-model="${dataPath}" ${multiSelect} ${disabled}>
    `;

    if (options.length) {
      if (options[0].value !== '' && !multiSelect) {
        fieldHtml += '<option value="">Select an Option</option>'
      }
      for (const opt of options) {
        fieldHtml += `
          <option value="${opt.value}">${opt.text}</option>
        `;
      }
    }

    fieldHtml += '</select>';

    if (fieldSubtext) {
      fieldHtml += `<div style="padding: 10px; color: #333333">${fieldSubtext}</div>`;
    }

    return fieldHtml;
  };

  /*
    Name: signature
    Use: API.signature()
    Args: field Object - Field configuration definition
    Description: signature control, a digital canvas
  */
  self.signature = function (field) {
    const {
      required,
      id,
      label,
      dataPath
    } = getFieldInfo(field);

    (function () {
      const canvas = document.querySelector(`#canvas_${id}`);
      const signaturePad = new SignaturePad(canvas, {
        onEnd: function () {
          const element = document.getElementById(id);
          const dataUrl = signaturePad.toDataURL();
          Vue.set(element, 'value', dataUrl);
          element.dispatchEvent(new Event('input'));
        },
      });
    }).After(1500);
    return `
      <label for="${id}" class="translateable">
        ${required ? '<sup class="fa fa-2xs fa-asterisk required-icon" title="Required"></sup> ' : ''}${label}
      </label>
      <div tabindex="0" aria-label="Signature input requires a mouse or touch">
        <div class="sr-only">
          Signature input requires a mouse or touch
        </div>
        <canvas id="canvas_${id}" style="border: 1px solid #EFEFEF;" width="500" height="180"></canvas>
        <input name="${id}" type="hidden" id="${id}" v-model="${dataPath}" />
      </div>
    `;
  };

  /*
			Name: reload
			Use: API.reload()
			Args: field Object - Field configuration definition
			Description: reload input control
		*/
  self.reload = function (field, renderedFormControl, jurisdiction) {
    const {
      required,
      id,
      label,
      childFields,
      actions,
      minDate,
      maxDate,
      minuteIncrement
    } = getFieldInfo(field);

    const addFlatPickr = function (vueInstance) {
      const getFieldConfig = (id) => {
        return vueInstance.childFields.find(cf => cf.properties.id === id);
      };

      $(`#reloadFields-${id} .date-field`).each(function () {
        const fieldConfig = getFieldConfig(this.id);
        const fdEl = document.getElementById(this.id);

        // system specific date format, configured to be accepted by flatpickr
        const displayFormat = (fieldConfig.properties?.dateFormat || jurisdiction.hscSettings?.dateFormat || 'MM/DD/YYYY')
          .toUpperCase()
          .replace('MMM', 'M')
          .replace('MM', 'm')
          .replace('DD', 'd')
          .replace('YYYY', 'Y');

        // Parse config option string, return a dateobject for use in flatpickr 'minTime' and 'maxTime' options
        const parseMinMaxDate = (string) => {
          // config string should be in the pattern of '-15D' for fifteen days ago, '3W' for 3 weeks ahead, etc
          // remove any spaces and split up the incoming config string
          const _string = string.replace(' ', '');
          const sign = _string.charAt(0);
          const offset = sign === '-' ? _string.slice(1, _string.length - 1) : _string.slice(0, _string.length - 1);

          // Moment uses upperCase 'M' to denote months in the below increment operation. Lowercase for (d)ay, (w)eek and (y)ear
          let unit = _string.slice(-1).toLowerCase().replace('m', 'M');

          // subtract from current date if first char in string is a minus sign, add if otherwise, then return the date object
          const limitDate = sign === '-' ? moment().subtract(offset, unit) : moment().add(offset, unit);
          return limitDate.toDate();
        };

        const datePickerConfig = {
          enableTime: false,
          noCalendar: false,
          defaultDate: fdEl.value ? moment(fdEl.value, displayFormat).toDate() : '', // default date read from input, empty string if not applicable
          allowInput: true,
          dateFormat: displayFormat,
          // altInput: true,
          // altFormat: displayFormat, // date format displayed to user... uses system date format or field date format 
          // altInputClass: `alt-datePicker alt-${fdEl.id} form-control w-input`,
          appendTo: fdEl.parentNode,
          position() {},
          mode: fieldConfig.properties.dateSelectMode ? fieldConfig.properties.dateSelectMode.toLowerCase() : 'single',
          disable: [
            (date) => {
              // the disable prop wants an array of dates, init empty array to hold dates
              let disabledDates = [];
              // disabled weekends
              if (fieldConfig.properties.disableWeekends) {
                (date.getDay() === 0 || date.getDay() === 6) && disabledDates.push(date);
              }
              // return disabled date array if it exists, empty string if not
              return disabledDates.length ? disabledDates : '';
            },
          ],
          minYear: parseMinMaxDate(fieldConfig.properties.minDate ?? "-5y").getFullYear(),
          maxYear: parseMinMaxDate(fieldConfig.properties.maxDate ?? "5y").getFullYear(),
          errorHandler(err) {
            /* Flatpickr yells at me when there is an empty input value
              - prevent console warning and flatpickr from setting input value as string "Invalid date" */
            if (err.message.includes('Invalid date')) {
            } else throw err;
          },
          onClose(dates, currentdatestring, picker){
            picker.setDate(picker.input.value, true, displayFormat)
          },
          onReady(a, b, fp) {
            fp.input.setAttribute('aria-label', fieldConfig.properties.label);

            if (fieldConfig.properties.placeholder !== undefined) {
              fp.input.setAttribute('placeholder', fieldConfig.properties.placeholder);
            }
          },
          onChange(a, b, fp) {
            const value = b;
            // This ensures that the vue object registers the changed value from date picker
            vueInstance.fieldValues[fdEl.id] = value;
          },
          onDayCreate(dObj, dStr, fp, dayElem) {
            if ($(dayElem).attr('tabindex') == -1) {
              $(dayElem).attr('tabindex', 0);
            }
          },
          onOpen(selectedDates, dateStr, instance) {
            instance.monthElements[0].setAttribute('tabindex', 0);
            instance.currentYearElement.setAttribute('tabindex', 0);
          },
        };

        // call flatpickr instance, attach it to the current field, pass in defined config options.
        const instance = flatpickr(fdEl, datePickerConfig);

        // force flatpickr to recognize updates when user clicks away after using keyboard to input date
        // tabbing away from the input or pressing 'enter' automatically trigger the update
        $(`input.alt-${fdEl.id}`).on('blur', function () {
          instance.updateValue();
        });
      });

      $(`#reloadFields-${id} .time-field`).each(function () {
        const fieldConfig = getFieldConfig($(this).prop('id'));
        const fdEl = document.getElementById(fieldConfig.properties.id);

        const datePickerConfig = {
          enableTime: true,
          noCalendar: true,
          defaultDate: vueInstance.fieldValues[fdEl.id] ? moment(vueInstance.fieldValues[fdEl.id], 'HH:mm A').toDate() : '', // default date read from input, empty string if not applicable
          dateFormat: 'h:i K',
          time_24hr: fieldConfig.properties.twentyFourHr,
          minuteIncrement: fieldConfig.properties.minuteIncrement ? fieldConfig.properties.minuteIncrement : 5,
          allowInput: true,
          // altInput: true,
          // altFormat: fieldConfig.properties.twentyFourHr ? 'H:i' : 'h:i K',
          // altInputClass: `alt-timePicker alt-reloadField-${id}-${fdEl.id} form-control w-input`,
          appendTo: fdEl.parentNode,
          position() {},
          minTime: fieldConfig.properties.minTime ? fieldConfig.properties.minTime : null,
          maxTime: fieldConfig.properties.maxTime ? fieldConfig.properties.maxTime : null,
          onReady(a, b, fp) {
            fp.input.setAttribute('aria-label', fieldConfig.properties.label);

            if (fieldConfig.properties.placeholder !== undefined) {
              fp.input.setAttribute('placeholder', fieldConfig.properties.placeholder);
            } else {
              fp.input.setAttribute('placeholder', "00:00 AM");
            }
          },
          onClose(dates, currentdatestring, picker){
            picker.setDate(picker.input.value, true, picker.config.dateFormat)
          },
          onChange(a, b, fp) {
            const value = b;
            // This ensures that the vue object registers the changed value from date picker
            vueInstance.fieldValues[fdEl.id] = value;
          },
          onOpen(selectedDates, dateStr, instance) {
            const fields = ['hour', 'minute', 'am-pm'];
            for (const field of fields) {
              const $field = $(`.flatpickr-${field}:visible`);
              if ($field.attr('tabindex') == -1) {
                $field.attr('tabindex', 0);
              }
            }
            // Allow manual input but direct focus to the timepicker ui once the field is interacted with.
            if (fieldConfig.properties.timeFocus) {
              $(`input.numInput.flatpickr-hour`).focus();
            }
          },
        };

        // call flatpickr instance, attach it to the current field, pass in defined config options.
        const instance = flatpickr(fdEl, datePickerConfig);

        // force flatpickr to recognize updates when user clicks away after using keyboard to input date
        // tabbing away from the input or pressing 'enter' automatically trigger the update
        $(`input.alt-reloadField-${id}-${fdEl.id}`).on('blur', function () {
          instance.updateValue();
        });
      });
    }

    setTimeout(function () {
      // Define the methods to use in the Vue here, so we can add onto it if needed.

      let reloadElement = document.getElementById(`reloadContainerShmainer${id}`),
        pageContentElement = document.getElementById('page-content'),
        mainFormElement = document.getElementById('email-form');

      if (!reloadElement) {
        reloadElement = document.createElement('div');
        reloadElement.id = `reloadContainerShmainer${id}`;
        pageContentElement.appendChild(reloadElement);
      }

      if (reloadElement && mainFormElement) {
        reloadElement.innerHTML = `
          <textarea id="${id}_values" style="display:none;">{{values}}</textarea>

          <div id="${id}" class="reload-entry" style="overflow-x: auto;">
            <div class="reload-entry-header">
              <h4 class="reload-entry-header-reloadName">${required ? '<sup class="fa fa-2xs fa-asterisk required-icon" title="Required"></sup> ' : ''}{{reloadName}}</h4>
              <button v-show="!showEntry" type="button" class="w-button reload-add" v-on:click="add($event)" data-reloadid="${id}">
                + Add
              </button>
            </div>
            <div v-show="showEntry" id="reloadFields-${id}" class="reload-entry-data-entry">
              {[childFields]}
                <div id="reloadField-${id}-{properties.id}">
							    {helpers.renderField}
                </div>
              {[/childFields]}
              <div class="reload-entry-controls">
                <button type="button" class="w-button reload-save" v-on:click="save" data-reloadid="${id}">
                  Save
                </button>
                <button type="button" class="w-button reload-cancel" v-on:click="cancel" data-reloadid="${id}">
                  Cancel
                </button>
              </div>
            </div>
            <table v-show="!showEntry" class="reload-entry-table table table-striped table-bordered" id="table-${
              id
            }">
              <tr>
              <th v-for="(childField, index) in visibleReloadFields" v-on:click="vueSort(index)" style="cursor:pointer"><span class="arrow" v-bind:class="currentSortDir === 'DESC' ? 'fa fa-caret-down' : 'fa fa-caret-up'"></span>{{childField.properties.label}}
                </th>
              <th>Edit</th>
              <th>Delete</th>
              </tr>
              <tbody>
              <tr v-for="(row, index) in data">
                <td v-for="childField in visibleReloadFields">{{ formatReloadRows(row, childField) }}</td>
                <td v-on:click="vueEdit(index)"><a href="javascript:void(0);"><span class="fa fa-pencil" aria-hidden="false"></span></a></td>
                <td v-on:click="initDelete(index)"><a href="javascript:void(0);"><span class="fa fa-remove" aria-hidden="false"></span></a></td>
              </tr>
              </tbody>
            </table>
          </div>
        `;

        // Compile the child field template separately to avoid compiling vue mustache variables
        const relEntryFlds = $(`#reloadFields-${id}`)[0];
        const compiledReloadTemplate = relEntryFlds.innerHTML.compile({
          childFields,
          helpers: {
            renderField: function (childField) {
              // Set the dataPath so that vue knows to bind each childField to fieldValues[childField.properties.id]
              childField.dataPath = `fieldValues.${childField.properties.id}`;
              return (app.ui.fieldController[childField.type] || app.ui.fieldController['default'])(
                childField,
                renderedFormControl,
                jurisdiction
              );
            },
          },
        });

        const reloadCalculationFields = childFields.filter(item => item.type === "calculation");
        reloadCalculationFields.map(item => {
          app.ui.liveFieldCalculation(item, childFields);
        });

        relEntryFlds.innerHTML = compiledReloadTemplate.replaceAll("@$@", "{").replaceAll("@&@", "}");
        formValidationService.add(`reloadFields-${id}`, "email-form", childFields, {
          errorsToValidate: ['patternMismatch', 'valueMissing'],
          validateWhen: formValidationService.VALIDATE_WHEN_OPTIONS.NONE,
          validateIf: formValidationService.VALIDATE_IF_OPTIONS.DIRTY,
          prependLabelToError: true,
          onError: (validationState) => {
            const firstInvalidField = Object.values(validationState.invalid)[0];
            if (firstInvalidField && firstInvalidField.element && firstInvalidField.message) {
              alert(firstInvalidField.message);
              firstInvalidField.element.focus();
              const $msgBar = $('.w-form-fail div');
              $('.w-form-fail').css('display', 'block');
              $msgBar.html(firstInvalidField.message).css("cursor", "pointer")
              if (firstInvalidField.message) {
                $msgBar.click(() => {
                  firstInvalidField.element.focus();
                });
              }
            }
          },
        });
      }
    }, 1100);

    setTimeout(function () {
      // If additional actions have been defined by the parent, add them now.
      for (const attrname in actions) {
        methodObj[attrname] = actions[attrname].bind(this);
      }

      const vueInstance = new Vue({
        el: `#reloadContainerShmainer${id}`,
        data: {
          currentSortDir: 'DESC',
          reloadName: label,
          childFields,
          reloadID: id,
          args: field,
          data: [],
          values: '',
          showEntry: false,
          editInd: -1,
          fieldValues: {},
          debug: false,
          id: null,
        },
        mounted: function () {
          const urlArgs = app.hashRouter.getUrlArgs();
          const draftsUrlParam = urlArgs?.drafts;
          const urlID = urlArgs?.id;

          //If the 'drafts' and 'id' param exists we are on the drafts page, so we can continue
          if (draftsUrlParam && urlID) {
            //self.data.push(JSON.parse(JSON.stringify(tempRec)));
          }
        },
        computed: {
          visibleReloadFields: function () {
            return this.childFields.filter((childField) => {
              return !childField.properties.hideFromReloadTable;
            });
          },
        },
        methods: {
          cancel: function () {
            this.showEntry = false;
            this.editInd = -1;
          },
          save: function () {
            const recordData = this.fieldValues;

            const validationResult = formValidationService.get(`reloadFields-${id}`).testValidity();
            if (!validationResult.isValid) return;

            this.showEntry = false;

            if (this.editInd < 0) {
              this.data.push(recordData);
            } else {
              this.data.splice(this.editInd, 1, recordData);
              this.editInd = -1;
            }

            this.values = JSON.stringify(this.data);

            // Clear entry fields
            this.fieldValues = {};
          },
          add: function () {
            this.isNew = true;
            this.showEntry = true;

            this.id = this.id || app.misc.guid();

            app.events.emit(`ui.controls.reload.${this.reloadID}`, {
              event: 'FORM_RENDERED',
              type: 'ADD',
            });

            this.childFields.forEach((childField) => {
              //	NOTE:
              //		Bind events for both Vue and app.events so change listeners are fired appropriately
              //		- sg 08/22/2016
              const key = childField.properties.id;

              // Add default values
              if ('default' in childField && childField.default) {
                const defaultValue = childField.default.compile({
                  now: moment().format('YYYY-MM-DD'),
                  nowTime: moment().format('h:mm A')
                });
                this.$set(this.fieldValues, key, defaultValue);
              } else {
                this.$set(this.fieldValues, key, '');
              }

              app.events.add(`ui.${key}`);

              //	NOTE:
              //		Emit the value "change" so any presaved values on update will have logic executed
              app.events.emit(`ui.${key}`, {
                id: key,
                newValue: '',
                oldValue: '',
              });

              this.$watch(`fieldValues.${key}`, function (newValue, oldValue) {
                //Emit the event with the id of the field, the new value and old value
                app.events.emit('formValuesChanged', {
                  id: `reload.${key}`,
                  newValue: newValue,
                  oldValue: oldValue,
                });
                app.events.emit(`ui.${key}`, {
                  id: key,
                  newValue: newValue,
                  oldValue: oldValue,
                });
              });
            });

            // emit an update event when values changed from saving a reload item
            this.$watch("values", function (newValue, oldValue) {
              app.events.emit('ui.' + this.reloadID, {
                id: this.reloadID,
                newValue: newValue
              });
            });

            addFlatPickr(this);
          },
          initDelete: function (ind) {
            if (confirm('Are you sure you want to remove this?')) {
              this.reallyDelete(ind);
            }
          },
          reallyDelete: function (ind) {
            this.data.splice(ind, 1);

            app.events.emit(`ui.controls.reload.${this.reloadID}`, {
              event: 'FORM_RENDERED',
              type: 'DELETE',
            });

            this.values = JSON.stringify(this.data);

            // emit an update event
            app.events.emit(`ui.${this.reloadID}`, {
              id: this.reloadID,
              newValue: this.data,
            });
          },
          vueEdit: function (ind) {
            this.isNew = false;
            this.editInd = ind;
            this.showEntry = true;

            this.fieldValues = JSON.clone(this.data[ind]);

            addFlatPickr(this);

            app.events.emit(`ui.controls.reload.${this.reloadID}`, {
              event: 'FORM_RENDERED',
              type: 'EDIT',
            });
          },
          vueSort: function (sortIndex) {
            const childField = this.childFields[sortIndex];

            // Get the rows of the reload table...remove header row
            const rows = Array.from($(`#table-${id}`)[0].rows);
            rows.shift();

            // Get pretty (display) data for column being sorted
            const prettyData = rows.map((row) => {
              return row.cells[sortIndex].textContent;
            });

            // if childfield is a select/dropdown .. sort by the display/pretty values
            if (childField.type === 'select') {
              const tempArr = this.data.map((row, index) => {
                row[childField.properties.id] = prettyData[index];
                row.origIndex = index;
                return row;
              });
              // Sort the temp array with pretty data
              tempArr.SortByAttribute(childField.properties.id, this.currentSortDir);

              // Add the data back into the correct sorted indices here
              const sortedData = [];
              for (const sortedRow of tempArr) {
                sortedData.push(this.data[sortedRow.origIndex]);
              }

              this.data = sortedData;
            } else {
              // Sort the data directly here
              this.data.SortByAttribute(
                childField.properties.id,
                this.currentSortDir,
                childField.type === 'date' || childField.type === 'time' ? childField.type : ''
              );
            }

            if (this.currentSortDir === 'ASC') {
              this.currentSortDir = 'DESC';
            } else if (this.currentSortDir === 'DESC') {
              this.currentSortDir = 'ASC';
            }

            this.values = JSON.stringify(this.data);
          },
          formatReloadRows: field?.args?.formatRowColumn ?
            field.args.formatRowColumn : function (row, column) {
              let result = row[column.properties.id];

              if (result !== undefined) {
                if (column.type === 'number') {
                  const setFormat = column.properties.mask !== undefined ? column.properties.mask : '0,0.00';

                  if (result === '') {
                    result = '';
                  } else {
                    try {
                      result = numeral(result).format(setFormat);
                    } catch (err) {
                      result = result.toString().replace(/,(?=.*\.\d+)/g, '');
                      result = Math.trunc(result);
                    }
                  }
                } else if (column.type === 'money') {
                  result = numeral(result)
                    .format(column.properties.mask !== undefined ? column.properties.mask : '0,0.00')
                    .prepend('$');
                } else if (column.type === 'date' || column.type === 'time') {
                  const mom = moment(result);

                  if (mom.isValid()) {
                    if (column.type === 'date') {
                      result = mom.format(jurisdiction.hscSettings?.dateFormat?.toUpperCase() || 'MM/DD/YYYY');
                    } else {
                      result = mom.format('hh:mm A');
                    }
                  }
                } else if (column.type === 'phone') {
                  if (result.toString().trim() !== '') {
                    const digits = result.toString().replace(/\D/gi, '').split('');

                    result = '';

                    digits.forEach(function (dig, idx) {
                      if (idx === 0 && digits.length > 7) {
                        result += '(';
                      } else if (idx === 3 && digits.length > 7) {
                        result += ') ';
                      } else if (idx === 10 && digits.length > 10) {
                        result += ' ext. ';
                      } else if ((idx === 6 && digits.length > 7) || (idx === 3 && digits.length <= 7)) {
                        result += '-';
                      }
                      result += dig.toString();
                    });
                  }
                } else if (
                  column.type === 'select' &&
                  'out' in column.options &&
                  column.options.out.replace(/\s/g, '')
                ) {
                  // Only do the following for 'select' field with form options... which should be indicated by formID having a value
                  const dataStore = app.dataStore.get();
                  const outRegEx = /{(.*?)}/g;
                  const recordID = result;
                  const formID = column.options?.formID;

                  if (formID) {
                    if (formID in dataStore.UI?.Options && dataStore.UI?.Options[formID].length > 0) {
                      /* Convert ID to out values. Should use .find() instead of .foreach()
                      once ES2015 browser support becomes prevalent. */
                      dataStore.UI.Options[formID].forEach(function (optionRow) {
                        // If we have a val defined we need to compare to that. Otherwise it's a normal column comparison.
                        const compareCol = column.options.val.replace(/\s/g, '') ?
                          column.options.val.replace(outRegEx, function (match, offset) {
                            return optionRow[offset];
                          }) :
                          column.properties.id;

                        if (compareCol === result) {
                          result = column.options.out.replace(outRegEx, function (match, offset) {
                            return optionRow[offset];
                          });
                        }
                      });

                      // Implements new filtering options that were added to cacheFieldoptions
                      if (dataStore.UI?.OptionsRow[formID][recordID]) {
                        optionRow = dataStore.UI.OptionsRow[formID][recordID];
                        // If we have a val defined we need to compare to that. Otherwise it's a normal column comparison.
                        result = column.options.out.compile(optionRow);
                      }
                    }
                  }
                } else if (column.type === 'select' && Array.isArray(column.options)) {
                  // This is for a 'select' field with attached options.. backend value may NOT be the same as the label
                  result =
                    column.options.find((opt) => {
                      return opt.value === result;
                    })?.text || result;
                }
              }

              const suffix = column?.suffix || '';
              if (suffix) result += ' ' + suffix;

              const prefix = column?.prefix || '';
              if (prefix) result = prefix + ' ' + result;

              return result;
            },
        },
      });
    }, 1500);
    return `<div id="reloadContainerShmainer${id}"></div>`;
  };

  // hidden in myHD
  self.spacer = function (field) {
    return ``;
  };

  // calculation is a hidden field
  self.calculation = function (field) {
    return ``;
  };

  /*
    Name: secure
    Use: API.secure()
    Args: field Object - Field configuration definition
    Description: Textarea control
  */
  self.secure = function (field) {
    const {
      required,
      id,
      label,
      placeholder,
      dataPath,
      inputMask,
      secureInput
    } = getFieldInfo(field);

    return `
      <label for="secure\$${id}">
        ${required ? '<sup class="fa fa-2xs fa-asterisk required-icon" title="Required"></sup> ' : ''}${label}
      </label>
      <input type="${secureInput}" class="form-control w-input" name="secure\$${id}" id="secure\$${id}"
        ${placeholder}
        ${inputMask}
        data-path="${dataPath}"
        v-model="${dataPath}"
      />
    `;
  };

  return self;
});